<template>
    <master-default>
      Redirecionando...
    </master-default>
</template>

<script>
try{
  var _base = require("@/page/_base.vue").default;
}catch(err){
  var _base = require("@/framework/page/_base.vue").default;
}


export default {
  extends: _base,

  data () {
    return {
    }
  },
  beforeMount(){
    if(this.$store.state.user==null){
      this.$router.replace({
        path:"/admin/login"
      })
    }else{
      this.$router.replace({
        path:"/admin/page/cockpit"
      })    
    }
  },
  components: {
    masterDefault: global.reqClass.requirecmpmix('@/masters/default'),
  }
}
</script>

